/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Modal from "../Modal/index";
import SmsVerification from "./SmsVerification";
import NumberFormat from "react-number-format";
import ReactPixel from "react-facebook-pixel";
import { forgotPasswords, selectPassword } from "../../../state/ducks/password";
import $ from "jquery";
import StaticModal from "../shared/StaticModal";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import { selectAlertMessage } from "../../../state/ducks/alert";
import Inputmask from "inputmask";

function changebg(corporate) {
  if (corporate) {
    var num = Math.ceil(Math.random() * 2);
    document.body.background = "/assets/img/loginBackground/loginback_" + num + ".jpg";
  } else {
    num = Math.ceil(Math.random() * 2);
    document.body.background = "/assets/img/loginBackground/loginback_" + num + ".jpg";
  }
}
function sifreAlControl() {
  var tcno = document.getElementById('tcKimlikNo').value;
  tcno = tcno.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum

  var telno = document.getElementById('telefonnumarasi').value;
  telno = telno.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum

  var hata = 0;

  if (telno.length < 10) {

    document.getElementById('telefonnumarasi').parentElement.classList.add("t-error"); // kutunun içini kırmızız yapıyorum.
    document.getElementById("telefonnumarasi").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
    hata = 1;
  } else {
    document.getElementById('telefonnumarasi').parentElement.classList.remove("t-error"); // kutunun içini kırmızız yapıyorum.
    document.getElementById("telefonnumarasi").nextElementSibling.innerHTML = "";
  }
  return hata;
}

class ForgotPassword extends Component {
  state = {
    corporate: this.props.match.params.type === "corporate",
    corporateCss: "",
    kimlikNo: "",
    gsm: "",
    token: "",
  };
  maskAndRegexInput() {
    var tckimlikno = document.getElementById("tcKimlikNo");
    var telefonnumarasi = document.getElementById("telefonnumarasi");
    if (tckimlikno != null && telefonnumarasi != null) {

      Inputmask("(999) 999-99-99").mask(telefonnumarasi);
      Inputmask({ regex: "[0-9]{11}" }).mask(tckimlikno);
    }

  }

  componentDidMount() {
    this.maskAndRegexInput();
    if (this.state.corporate === true) {
      this.setState({ corporateCss: "-krmsl" });
    }
    $(".react-datepicker-wrapper").addClass("form-control");
    changebg(this.state.corporate);
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
    this.createCaptchaToken();
  }

  submit = (event) => {
    event.preventDefault();
    var control = sifreAlControl()

    if (control == 0) {
      var _kimlikNo = this.state.kimlikNo.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum

      const data = {
        kimlikNo: _kimlikNo,
        gsm: this.state.gsm,
        token: this.state.token,
      };
      this.props.forgotPasswords(data);
      this.createCaptchaToken();
    }
  };

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  render() {
    const { alert } = this.props;
    let krmsl = this.state.corporateCss;
    return (
      <LoadingOverlay active={alert?.loading} spinner={<ClipLoader />} styles={{
        overlay: (base) => ({
          ...base,
          position: 'fixed'
        })
      }}>
        <div>
          <Modal message={alert?.message} type={alert?.type} />
          <div className="container-fluid">
            <form onSubmit={this.submit}>
              <div className="row d-flex align-items-center justify-content-center vh-100">
                <div
                  className="col-10 col-md-7 col-lg-6 col-xl-4 t-sifreAlani"
                
                >
                  <div className="row no-gutters d-flex justify-content-center px-4">
                    {/* LOGO */}
                    <div className="col-12 d-flex justify-content-center pb-2">
                      <i className="t-icon-phone1 t-loginSifreAlBaslikIcon" />
                    </div>
                    <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                      ANINDA ŞİFRE AL
                    </div>
                    {/* TC Kimlik */}
                    <div className="col-12 col-lg-10 col-xl-8 pb-2">
                      <span className="t-loginText pl-3">TC Kimlik / VKN / Üye No</span>
                    </div>
                    <div className="col-12 col-lg-10 col-xl-8">
                      <div className="t-inputLogin">
                        <div>
                          <img src="./assets/img/svg/icon_ayyildiz.svg" width="25" height="22" />
                        </div>
                        <input
                          type="text"
                          id="tcKimlikNo"
                          className="decimalnumber"
                          placeholder="TC Kimlik / VKN / Üye Numaranızı Giriniz"
                          value={this.state.kimlikNo}
                          onChange={(e) => {
                            this.setState({ kimlikNo: e.target.value });
                          }}
                          maxLength={11}
                        />
                        <div />
                      </div>
                    </div>
                    {/* GSM No */}
                    <div className="col-12 col-lg-10 col-xl-8 pt-3 pb-2">
                      <span className="t-loginText pl-3">GSM Numaranız</span>
                    </div>
                    <div className="col-12 col-lg-10 col-xl-8">
                      <div className="t-inputLogin">
                        <div>
                          <i className="t-icon-phone1" />
                        </div>
                        <input
                          id="telefonnumarasi"
                          className="telefonnumber"
                          type="text"
                          placeholder="(5__) ___-__-__"
                          value={this.state.gsm}
                          onChange={(e) => {
                            this.setState({ gsm: e.target.value.replace(/\D/g, '') });
                          }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* ara boşluk*/}
                    <div className="col-12" />
                    {/* GİRİŞ ve GERİ DON */}
                    <div className="col-auto pt-4 px-1">
                      <a
                        href="./giris"
                        target="_parent"
                        className="t-loginGeridonButton"
                      >
                        <i className="t-icon-arrow-left2" style={{ fontSize: "14pt" }} />
                        GERİ DÖN
                        <span />
                      </a>
                    </div>
                    <div className="col-auto pt-4 px-1">
                      <button
                        type="submit"
                        className="t-loginGirisButton"

                      >
                        <span className="px-2" />
                        DEVAM ET
                        <i
                          className="t-icon-arrow-right2 pl-2"
                          style={{ fontSize: "14pt" }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <StaticModal></StaticModal>
          <SmsVerification
            kimlikNo={this.state.kimlikNo}
            corporate={this.state.corporate}
          ></SmsVerification>
        </div>
      </LoadingOverlay>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    password: selectPassword(state),
    alert: selectAlertMessage(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  forgotPasswords: (data) => dispatch(forgotPasswords(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
